<template>
  <div v-if="mounted" class="bm-privacy__modal">
    <div class="bm-privacy__modal__backdrop"></div>
    <div class="bm-privacy__modal__container" :class="{ show: opened }" @click="markEvent">
      <slot></slot>
    </div>
  </div>
</template>

<script type="text/javascript">
export default {
  name: 'BmPrivacyModalComponent',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    mounted: false,
    opened: false
  }),
  watch: {
    visible: function (newValue) {
      if (newValue) {
        this.open()
      } else {
        this.close()
      }
    }
  },
  methods: {
    markEvent (event) {
      event.bmPrivacyModal = true
    },
    open () {
      this.mounted = true
      this.$emit('open')
      setTimeout(() => {
        this.opened = true
        window.addEventListener('click', this.clickListener)
      })
      setTimeout(() => {
        this.$emit('opened')
      }, 300)
    },
    close () {
      this.opened = false
      window.removeEventListener('click', this.clickListener)
      this.$emit('close')
      setTimeout(() => {
        this.mounted = false
        this.$emit('closed')
      }, 300)
    },
    clickListener (event) {
      if (event.bmPrivacyModal) {
        return
      }
      this.close()
    }
  }
}
</script>
